// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';


import Approval from './components/Approval.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";
import remrecdata from "./common/remrecdata1.json"

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.model = model;
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args) => {
                invoke(eventName, args)
            }
            Vue.prototype.eventBus = eventBus;
            new Vue({
                el: model.dom,
                template: '<Approval :remRecData="cusParam_personObj" :cusParam_op="cusParam_op" />',
                components: {
                    Approval
                },
                data: {
                    cusParam_personObj:null,
                    cusParam_op:null
                },
                beforeCreate() {
                },
                destoryed() {
                    console.log('Vue destory ')
                    eventBus.unsub(this.subUpdate)
                },
                mounted() {
                    this.cusParam_personObj = remrecdata;
                    if (props.themeNum) {
                        this.themeNum = props.themeNum;
                    }
                    if (props.lang) {
                        this.lang = props.lang;
                    }
                    if (props.data) {
                        this.getCusParam(props, "cusParam_personObj");
                    }
                    this.subUpdate = eventBus.sub(model, 'update', (props) => {
                        if (props.themeNum) {
                            this.themeNum = props.themeNum;
                        }
                        if (!props.data) {
                            return
                        }
                        this.getCusParam(props, "cusParam_personObj");
                        this.getCusParam(props,"cusParam_op");
                    })
                },
                methods: {
                    getCusParam(props, key) {
                        if (props.data.hasOwnProperty(key) && props.data[key]) {
                            this[key] = props.data[key] ? JSON.parse(props.data[key]) : null;
                        }
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('soeapproval', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)
